<app-painel-comissoes
    tituloPainel="Frequência de Comissões"
    descricaoPainel="Matriz de presença dos membros por reunião, com percentual individual e quórum por encontro."
    iconePainel="pi pi-table"
    [filtrosTemplate]="filtros"
    [conteudoTemplate]="conteudo"
>
    <ng-template #filtros>
        <label class="mapa-filtro" for="frequencia-ano">
            <span class="mapa-filtro-label">Ano</span>
            <input id="frequencia-ano" type="number" class="frequencia-input-ano" [(ngModel)]="ano" (change)="onAnoChange()" min="2000" max="2100" />
        </label>

        <label class="mapa-filtro" for="frequencia-uf">
            <span class="mapa-filtro-label">UF</span>
            <app-estado-select [uf]="ufSelecionada ?? 'BR'" [ufsPermitidas]="ufsPermitidas" (ufChange)="onUfChange($event)"></app-estado-select>
        </label>

        <label class="mapa-filtro" for="frequencia-comissao">
            <span class="mapa-filtro-label">Comissão</span>
            <p-select
                inputId="frequencia-comissao"
                [options]="comissoes()"
                optionLabel="descricao"
                optionValue="idEstrutura"
                [(ngModel)]="idEstruturaSelecionada"
                [showClear]="true"
                [filter]="true"
                placeholder="Selecione..."
                [loading]="carregandoComissoes()"
                [disabled]="carregandoComissoes() || !comissoes().length"
                appendTo="body"
                styleClass="w-full"
            ></p-select>
        </label>

        <div class="filtros-acoes">
            <p-button icon="pi pi-search" label="Gerar" type="button" [loading]="carregando()" [disabled]="!idEstruturaSelecionada" [appCan]="rolePermissaoVisualizar" (onClick)="gerar()"></p-button>
        </div>
    </ng-template>

    <ng-template #conteudo>
        @if (carregando()) {
            <div class="frequencia-skeleton">
                <p-skeleton width="100%" height="52px"></p-skeleton>
                <p-skeleton width="100%" height="320px"></p-skeleton>
            </div>
        } @else if (erro()) {
            <div class="frequencia-estado frequencia-estado--erro">
                <i class="pi pi-exclamation-triangle"></i>
                <span>{{ erro() }}</span>
            </div>
        } @else if (!gerado()) {
            <div class="frequencia-estado">
                <i class="pi pi-table"></i>
                <span>Selecione uma comissão e clique em Gerar.</span>
            </div>
        } @else if (frequencia() && frequencia()?.membros?.length) {
            <div class="frequencia-resultado-cabecalho">
                <h3>{{ frequencia()?.descricaoComissao }} — {{ ano }}</h3>
                <p-button icon="pi pi-file-export" label="Exportar CSV" type="button" severity="secondary" [outlined]="true" [appCan]="rolePermissaoVisualizar" (onClick)="exportarCsv()"></p-button>
            </div>
            <app-frequencia-matriz [frequencia]="frequencia()"></app-frequencia-matriz>
        } @else {
            <div class="frequencia-estado">
                <i class="pi pi-inbox"></i>
                <span>Sem reuniões no período.</span>
            </div>
        }
    </ng-template>
</app-painel-comissoes>
